// Tracking GA4 cote theme — evenements du parcours configurateur (cadrage « Tracking GA4 — cadrage de
// reference », 2026-10-23). Documentation complete : docs/tracking-ga4.md.
//
// Perimetre : UNIQUEMENT les evenements propres au site (configurator_start, customization_select,
// configurator_complete, generate_lead). Les evenements e-commerce standard (page_view, view_item,
// add_to_cart, view_cart, begin_checkout, purchase...) restent envoyes par l'app Shopify « Google &
// YouTube » : ce script n'envoie JAMAIS page_view ni d'evenement e-commerce (pas de doublon).
//
// Consentement : gtag.js n'est charge qu'APRES consentement « analytics » (API de confidentialite
// Shopify, alimentee par Pandectes). Refus = aucun appel a Google, aucun cookie ; la capture e-mail
// continue de fonctionner (elle ne depend pas de ce script). Si le choix change plus tard
// (visitorConsentCollected), on suit : accepte -> on charge ; refuse -> on cesse d'envoyer.
//
// Donnees personnelles : aucun e-mail/nom/telephone ; le texte libre de gravure n'est jamais lu ici
// (seulement la presence d'une gravure : none / custom). Les cles suspectes sont filtrees en dernier
// recours (sanitize).
(function () {
  if (window.HexagonTracking) return;

  var GA_ID = 'G-5PH94M3BT1';
  var QUEUE_TTL_MS = 60000;
  var FIRST_TOUCH_TTL_MS = 90 * 24 * 60 * 60 * 1000;
  var CONSENT_WAIT_MS = 8000;
  var FORBIDDEN_KEY = /mail|phone|(^|_)tel(_|$)|name|(^|_)nom(_|$)|prenom|address|adresse|engrav|grav/i;

  var queue = [];
  var loaded = false;
  var loading = false;
  var consentKnown = false;
  var consentGranted = false;
  var firstCheckAt = Date.now();

  // ---------- stockage (jamais bloquant) ----------
  function ssGet(k) { try { return window.sessionStorage.getItem(k); } catch (e) { return null; } }
  function ssSet(k, v) { try { window.sessionStorage.setItem(k, v); } catch (e) { /* ignore */ } }
  function ssDel(k) { try { window.sessionStorage.removeItem(k); } catch (e) { /* ignore */ } }
  function lsGet(k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) { try { window.localStorage.setItem(k, v); } catch (e) { /* ignore */ } }

  // ---------- consentement ----------
  function privacyApi() {
    var s = window.Shopify;
    return s && s.customerPrivacy && typeof s.customerPrivacy.analyticsProcessingAllowed === 'function' ? s.customerPrivacy : null;
  }
  function readConsent() {
    var api = privacyApi();
    if (!api) return false; // API pas encore chargee : on n'a pas de preuve de consentement
    consentKnown = true;
    try { return !!api.analyticsProcessingAllowed(); } catch (e) { return false; }
  }
  // ---------- Microsoft Clarity ----------
  // L'app Shopify Clarity se declare « toujours active » : Shopify ne peut donc pas la bloquer, et elle
  // envoyait des donnees (b.clarity.ms/collect, sans cookie) meme apres un refus. Clarity expose
  // window.clarity('stop') : on l'appelle des que le consentement analytics est refuse (ou retire).
  // Un consentement accorde apres un arret n'est repris qu'a la page suivante (rechargement).
  var clarityStopped = false;
  function stopClarity() {
    if (clarityStopped) return;
    var tries = 0;
    (function attempt() {
      if (typeof window.clarity === 'function') {
        try { window.clarity('stop'); clarityStopped = true; } catch (e) { /* ignore */ }
        return;
      }
      tries += 1;
      if (tries < 80) window.setTimeout(attempt, 250); // Clarity peut se charger apres ce script
    })();
  }
  function refreshConsent() {
    var was = consentGranted;
    consentGranted = readConsent();
    if (consentKnown && !consentGranted) stopClarity();
    if (consentGranted) clarityStopped = false;
    if (consentGranted && !was) { loadGtag(); flush(); captureFirstTouch(); }
    if (!consentGranted && consentKnown) queue = []; // refus : on ne garde rien en memoire
    if (was && !consentGranted && window.hexagonGtag) {
      // Consentement retire apres coup : on demande a gtag de cesser tout stockage/mesure.
      window.hexagonGtag('consent', 'update', { analytics_storage: 'denied', ad_storage: 'denied', ad_user_data: 'denied', ad_personalization: 'denied' });
    }
    return consentGranted;
  }
  document.addEventListener('visitorConsentCollected', function () { window.setTimeout(refreshConsent, 0); });
  // L'API Shopify arrive parfois apres ce script : on re-verifie quelques secondes.
  (function poll() {
    refreshConsent();
    if (!consentKnown && Date.now() - firstCheckAt < CONSENT_WAIT_MS) window.setTimeout(poll, 400);
  })();

  // ---------- gtag ----------
  function loadGtag() {
    if (loaded || loading) return;
    loading = true;
    window.dataLayer = window.dataLayer || [];
    window.hexagonGtag = function () { window.dataLayer.push(arguments); };
    window.hexagonGtag('js', new Date());
    // send_page_view:false -> le page_view reste celui de l'app Google (aucun doublon).
    window.hexagonGtag('config', GA_ID, { send_page_view: false });
    // Recette : ?hx_debug=1 (memorise pour la session) active le mode debug GA4 -> GA4 > Admin > DebugView.
    try {
      if (/[?&]hx_debug=1/.test(window.location.search)) ssSet('hx_debug', '1');
      if (ssGet('hx_debug') === '1') window.hexagonGtag('set', { debug_mode: true });
    } catch (e) { /* ignore */ }
    var s = document.createElement('script');
    s.async = true;
    s.src = 'https://www.googletagmanager.com/gtag/js?id=' + encodeURIComponent(GA_ID);
    s.onload = function () { loaded = true; flush(); };
    s.onerror = function () { loading = false; };
    document.head.appendChild(s);
    loaded = true; // les commandes gtag s'empilent dans dataLayer meme avant la fin du chargement
  }

  function sanitize(params) {
    var out = {};
    Object.keys(params || {}).forEach(function (k) {
      if (FORBIDDEN_KEY.test(k) && k !== 'config_engraving' && k !== 'form_name') return;
      var v = params[k];
      if (v === undefined || v === null || v === '') return;
      if (typeof v === 'string') v = v.slice(0, 100);
      out[k] = v;
    });
    return out;
  }

  function send(name, params) {
    window.hexagonGtag('event', name, params);
  }
  function flush() {
    if (!consentGranted || !loaded) return;
    var now = Date.now();
    var items = queue.splice(0);
    items.forEach(function (it) { if (now - it.t <= QUEUE_TTL_MS) send(it.name, it.params); });
  }

  // ---------- Meta Pixel (app Shopify « Facebook & Instagram ») ----------
  // Le pixel Meta est charge par l'app Shopify, UNIQUEMENT si les finalites analytics + marketing +
  // vente de donnees sont accordees (Pandectes -> API de confidentialite Shopify). On ne charge rien
  // ici : on relaie seulement 4 signaux propres au site vers window.fbq s'il existe. Refus ou retrait
  // = fbq absent = aucun envoi. Evenements natifs (PageView, ViewContent, AddToCart, InitiateCheckout,
  // Purchase) : envoyes par l'app, jamais ici (pas de doublon). Lead = inscription e-mail CONFIRMEE.
  var META_MAP = {
    configurator_start: { std: false, name: 'ConfiguratorStart' },
    customization_select: { std: false, name: 'CustomizationSelect' },
    configurator_complete: { std: false, name: 'ConfiguratorComplete' },
    generate_lead: { std: true, name: 'Lead' }
  };
  var META_KEYS = ['configurator_type', 'customization_type', 'customization_group', 'customization_id', 'config_id', 'config_tamis', 'config_texture', 'config_finish', 'config_accent_color', 'config_logo_color', 'config_engraving', 'form_name'];
  var metaQueue = [];
  var metaTimer = null;
  // 'unknown' : l'API de confidentialite Shopify n'est pas encore chargee (page qui vient de se charger,
  // ex. retour ?contact_posted=true) -> on met en attente ; 'no' : refus -> on jette ; 'yes' : consentement.
  function metaState() {
    var api = window.Shopify && window.Shopify.customerPrivacy;
    if (!api || typeof api.marketingAllowed !== 'function' || typeof api.analyticsProcessingAllowed !== 'function') return 'unknown';
    try { return api.marketingAllowed() && api.analyticsProcessingAllowed() ? 'yes' : 'no'; } catch (e) { return 'unknown'; }
  }
  function metaSend(it) {
    var p = {};
    META_KEYS.forEach(function (k) { if (it.params[k] !== undefined) p[k] = it.params[k]; });
    if (it.def.std) {
      p.content_name = it.params.form_name || 'lead';
      window.fbq('track', it.def.name, p, { eventID: it.id });
    } else {
      window.fbq('trackCustom', it.def.name, p, { eventID: it.id });
    }
  }
  function metaFlush() {
    var st = metaState();
    if (st === 'no') { metaQueue = []; return; }
    if (st !== 'yes' || typeof window.fbq !== 'function') return;
    var now = Date.now();
    metaQueue.splice(0).forEach(function (it) { if (now - it.t <= QUEUE_TTL_MS) { try { metaSend(it); } catch (e) { /* ignore */ } } });
  }
  function metaRelay(name, params) {
    var def = META_MAP[name];
    if (!def || metaState() === 'no') return; // refus : rien n'est garde ni envoye
    metaQueue.push({ def: def, params: params, id: name + '_' + Date.now().toString(36) + Math.random().toString(36).slice(2, 7), t: Date.now() });
    metaFlush();
    if (metaQueue.length && !metaTimer) {
      // fbq est charge par l'app apres le consentement / au chargement de page : on patiente 15 s.
      var tries = 0;
      metaTimer = window.setInterval(function () {
        tries += 1;
        metaFlush();
        if (!metaQueue.length || tries > 30) { window.clearInterval(metaTimer); metaTimer = null; metaQueue = []; }
      }, 400);
    }
  }

  // API publique : event(name, params). Jamais d'exception vers l'appelant.
  function event(name, params) {
    try {
      var p = sanitize(params);
      metaRelay(name, p);
      p.transport_type = 'beacon'; // survit a la redirection vers /cart
      if (ssGet('hx_debug') === '1') p.debug_mode = true; // recette : visible dans GA4 > DebugView
      if (refreshConsent() && loaded) { send(name, p); return true; }
      if (consentKnown && !consentGranted) return false; // refus explicite : rien n'est envoye ni garde
      queue.push({ name: name, params: p, t: Date.now() }); // consentement pas encore connu : on attend
      return false;
    } catch (e) { return false; }
  }

  // ---------- attribution : premiere source externe / UTM (apres consentement) ----------
  var PAYMENT_HOSTS = /(^|\.)(shop\.app|shopify\.com|paypal\.com|stripe\.com|klarna\.com|alma\.eu|paypal\.me)$/i;
  function captureFirstTouch() {
    if (!consentGranted) return;
    // Premiere source conservee 90 jours ; passe ce delai, la prochaine arrivee la remplace.
    try {
      var prev = JSON.parse(lsGet('hx_first_touch') || 'null');
      if (prev && prev.ts && Date.now() - prev.ts < FIRST_TOUCH_TTL_MS) return;
    } catch (e) { /* valeur illisible : on la remplace */ }
    try {
      var qs = new URLSearchParams(window.location.search);
      var ref = '';
      try { ref = document.referrer ? new URL(document.referrer).hostname : ''; } catch (e) { ref = ''; }
      var own = window.location.hostname;
      var externalRef = ref && ref !== own && !PAYMENT_HOSTS.test(ref) ? ref : '';
      var ft = {
        source: qs.get('utm_source') || externalRef || '(direct)',
        medium: qs.get('utm_medium') || (externalRef ? 'referral' : '(none)'),
        campaign: qs.get('utm_campaign') || '',
        content: qs.get('utm_content') || '',
        term: qs.get('utm_term') || '',
        landing: window.location.pathname,
        ts: Date.now()
      };
      lsSet('hx_first_touch', JSON.stringify(ft));
    } catch (e) { /* ignore */ }
  }
  function firstTouchParams() {
    try {
      var ft = JSON.parse(lsGet('hx_first_touch') || 'null');
      if (!ft) return {};
      return { first_touch_source: ft.source, first_touch_medium: ft.medium, first_touch_campaign: ft.campaign, first_touch_landing: ft.landing };
    } catch (e) { return {}; }
  }
  document.addEventListener('visitorConsentCollected', function () { window.setTimeout(captureFirstTouch, 50); });
  window.setTimeout(captureFirstTouch, 600);

  // ---------- parcours configurateur ----------
  function cfgBase(type) { return { configurator_type: type }; }

  // Premier clic sur un choix (une fois par parcours et par type, sur la session navigateur).
  function started(type) {
    var key = 'hx_cfg_started_' + type;
    if (ssGet(key)) return;
    if (event('configurator_start', cfgBase(type))) ssSet(key, '1');
    else if (!consentKnown || consentGranted) ssSet(key, '1'); // mis en file : sera envoye au consentement
  }

  // Selection effective d'une option. aesthetic = finition / couleur / logo / texture.
  function customization(type, group, id, customizationType) {
    var p = cfgBase(type);
    p.customization_type = customizationType || 'aesthetic';
    p.customization_group = group;
    p.customization_id = id;
    event('customization_select', p);
  }

  // Resume de configuration NON personnel (ids stables). Sert aux evenements de validation.
  function configParams(type, cfg) {
    var p = cfgBase(type);
    cfg = cfg || {};
    p.config_id = cfg.configId;
    p.config_tamis = cfg.tamis;
    p.config_texture = cfg.texture;
    p.config_finish = cfg.finish;
    p.config_accent_color = cfg.accentColor;
    p.config_logo_color = cfg.logoColor;
    p.config_engraving = cfg.engraving; // 'none' | 'custom' — jamais le texte
    return p;
  }
  function completed(type, cfg) {
    var key = 'hx_cfg_done_' + (cfg && cfg.configId ? cfg.configId : type);
    if (ssGet(key)) return;
    var p = configParams(type, cfg);
    if (event('configurator_complete', p)) ssSet(key, '1');
  }

  // ---------- inscription e-mail (generate_lead) ----------
  var FORMS = {
    ConfiguratorNotifyForm: { form_name: 'configurator', type: 'racket_full' },
    TamisNotifyForm: { form_name: 'configurator', type: 'tamis_only' },
    HomeEmailInterestForm: { form_name: 'home_email', type: '' }
  };
  var PENDING_KEY = 'hx_lead_pending';
  var PENDING_TTL = 15 * 60 * 1000;

  // Appele AU SUBMIT du formulaire (avant le POST natif) : memorise la configuration non personnelle.
  function leadPending(formId, cfg) {
    var f = FORMS[formId];
    if (!f) return;
    ssSet(PENDING_KEY, JSON.stringify({ formId: formId, cfg: cfg || null, t: Date.now() }));
  }

  // Appele au retour de Shopify avec ?contact_posted=true (= enregistrement reussi cote serveur).
  // Consomme la memorisation : un rechargement de la page ne renvoie PAS l'evenement.
  function leadConfirmed(formId) {
    var f = FORMS[formId];
    if (!f) return;
    var pending = null;
    try { pending = JSON.parse(ssGet(PENDING_KEY) || 'null'); } catch (e) { pending = null; }
    ssDel(PENDING_KEY);
    if (!pending || pending.formId !== formId || Date.now() - pending.t > PENDING_TTL) return;
    if (f.type && pending.cfg) completed(f.type, pending.cfg); // en phase opening, l'envoi du formulaire EST la validation
    var p = { form_name: f.form_name };
    if (f.type) p.configurator_type = f.type;
    if (pending.cfg && pending.cfg.configId) p.config_id = pending.cfg.configId;
    var ft = firstTouchParams();
    Object.keys(ft).forEach(function (k) { p[k] = ft[k]; });
    event('generate_lead', p);
  }

  // Evenements historiques hexagon:* (panier, FAQ, Remplacer mon tamis) : ils partaient via le pixel
  // personnalise Shopify (Measurement Protocol, identifiant visiteur ALEATOIRE a chaque page => chaque
  // evenement apparaissait comme un nouvel utilisateur). Ils passent desormais par le meme gtag que les
  // autres evenements (meme identifiant visiteur, meme session, memes regles de consentement), avec les
  // MEMES noms qu'avant pour garder l'historique GA4. Le pixel personnalise est a deconnecter.
  var LEGACY = {
    'hexagon:cart-remove-click': 'hexagon_cart_remove_click',
    'hexagon:cart-remove-success': 'hexagon_cart_remove_success',
    'hexagon:cart-edit-click': 'hexagon_cart_edit_click',
    'hexagon:cart-checkout-click': 'hexagon_cart_checkout_click',
    'hexagon:cart-add-click': 'hexagon_configurator_add_click',
    'hexagon:cart-add-success': 'hexagon_configurator_add_success',
    'hexagon:cart-add-error': 'hexagon_configurator_add_error',
    'hexagon:faq-category-select': 'hexagon_faq_category_select',
    'hexagon:faq-question-open': 'hexagon_faq_question_open',
    'hexagon:rmt-tamis-select': 'hexagon_rmt_tamis_select',
    'hexagon:rmt-sim-view': 'hexagon_rmt_sim_view',
    'hexagon:rmt-sim-heures': 'hexagon_rmt_sim_heures',
    'hexagon:rmt-sim-prix': 'hexagon_rmt_sim_prix',
    'hexagon:rmt-sim-config': 'hexagon_rmt_sim_config',
    'hexagon:rmt-sim-level': 'hexagon_rmt_sim_level',
    'hexagon:rmt-cta-demande': 'hexagon_rmt_cta_demande',
    'hexagon:rmt-cta-contact': 'hexagon_rmt_cta_contact',
    'hexagon:rmt-faq-open': 'hexagon_rmt_faq_open',
    'hexagon:rmt-form-start': 'hexagon_rmt_form_start',
    'hexagon:rmt-form-error': 'hexagon_rmt_form_error',
    'hexagon:rmt-form-success': 'hexagon_rmt_form_success'
  };
  function legacy(name, detail) {
    var ga = LEGACY[name];
    if (!ga) return;
    var p = {};
    Object.keys(detail || {}).forEach(function (k) {
      var v = detail[k];
      if (typeof v === 'string' || typeof v === 'number' || typeof v === 'boolean') p[k] = v;
    });
    event(ga, p);
  }

  window.HexagonTracking = {
    event: event,
    legacy: legacy,
    started: started,
    customization: customization,
    completed: completed,
    leadPending: leadPending,
    leadConfirmed: leadConfirmed,
    configParams: configParams,
    _debug: function () { return { consentKnown: consentKnown, consentGranted: consentGranted, loaded: loaded, queued: queue.length }; }
  };
})();
